import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxCookieConsentComponent } from './rx-cookie-consent.component';
import { RxUiModule } from '@nrwl/rx-ui';
import { RxTipModule } from '@nrwl/rx-tip';

@NgModule({
  imports: [CommonModule, RxTipModule, RxUiModule, RxCookieConsentComponent],
  exports: [RxCookieConsentComponent],
})
export class RxCookieConsentModule {}
